import en from '@/lang/en';
import fr from '@/lang/fr';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

export const defaultNS = 'base';

export const resources = {
  en,
  fr,
} as const;

export function detectLanguage() {
  const lang = navigator?.language ?? 'fr';
  if (lang.includes('fr')) return 'fr';
  return 'en';
}

i18next
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: window.store.get('lang') ?? detectLanguage(), // if you're using a language detector, do not define the lng option
    fallbackLng: 'fr',
    ns: [
      'base',
      'quant',
      'accounts',
      'sidebar',
      'settings',
      'ranking',
      'rank',
      'challenges',
      'notify',
      'report',
      'auth',
      'affiliation',
      'metrix',
      'tradingTerminal',
      'copyPositions',
      'risk',
      'support',
      'economicTerminal',
      'propfirms',
      'communities',
      'moderation',
      'chart',
    ],
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });
